'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _translationToken = require('./translationToken');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_translationToken).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'TranslationListType', {
  enumerable: true,
  get: function get() {
    return _model.TranslationListType;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/translation-token/index.js
// module id = 461
// module chunks = 0